import GalaxyAvatar from "@galaxy-io/dls/avatar/Avatar";
import { PersonInspector } from "@/features/people/person-inspector";
import { safeUrl } from "@/lib/utils";
export function ProfileDrawer({ id, onClose }: { id: string | null; onClose: () => void }) {
  return <PersonInspector id={id} onClose={onClose} />;
}
export function Avatar({
  src,
  name,
  large = false,
  small = false,
}: {
  src: string;
  name: string;
  large?: boolean;
  small?: boolean;
}) {
  return (
    <div role="img" aria-label={`${name}'s avatar`}>
      <GalaxyAvatar img={safeUrl(src)} seed={name} size={large ? 64 : small ? 24 : 36} />
    </div>
  );
}
